import { render, staticRenderFns } from "./ThemeEditDialog.vue?vue&type=template&id=a035454e"
import script from "./ThemeEditDialog.vue?vue&type=script&lang=js"
export * from "./ThemeEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports